/* Engravita v7 · cookie consent (snippets/eg7-consent.liquid). Same behaviour as the banners on 3dindustriprint.dk
   and sevecu.dk: nothing optional is allowed until the visitor chooses, Afvis alle and Acceptér alle are equal, the
   optional toggles start off every time the banner opens (no pre-ticked boxes), and the choice lasts 12 months.
   On Shopify the choice is handed to the Customer Privacy API (setTrackingConsent): Shopify's own analytics and every
   app pixel (Meta) obey it, and the checkout reads the same _tracking_consent cookie. */
(()=>{
const tpl=document.getElementById('eg7-consent-tpl');
if(!tpl||window.eg7Consent)return;

const KEY='eg7_consent',MONTHS=12,CATS=['preferences','analytics','marketing'],HASH='#cookieindstillinger';
const NONE={preferences:false,analytics:false,marketing:false},ALL={preferences:true,analytics:true,marketing:true};
const reduce=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
const root=document.documentElement;

/* ---- the stored choice: {v,preferences,analytics,marketing,at}, forgotten 12 months after it was given ---- */
const read=(now=new Date())=>{
  let c=null;
  try{c=JSON.parse(localStorage.getItem(KEY)||'null')}catch(e){return null}
  if(!c||c.v!==1||!CATS.every(k=>typeof c[k]==='boolean'))return null;
  const exp=new Date(c.at);
  if(isNaN(exp))return null;
  exp.setMonth(exp.getMonth()+MONTHS);
  if(now>=exp){try{localStorage.removeItem(KEY)}catch(e){}return null}
  return {preferences:c.preferences,analytics:c.analytics,marketing:c.marketing};
};
const write=c=>{try{localStorage.setItem(KEY,JSON.stringify({v:1,...c,at:new Date().toISOString()}))}catch(e){}};

/* ---- Shopify Customer Privacy API ---- */
let api;
const privacy=()=>api||(api=new Promise(res=>{
  const S=window.Shopify,done=()=>res(window.Shopify&&window.Shopify.customerPrivacy||null);
  if(S&&S.customerPrivacy)return done();
  if(S&&typeof S.loadFeatures==='function'){try{S.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],done)}catch(e){done()}}
  else done();
  setTimeout(done,8000);
}));
const yes=v=>v?'yes':'no';
/* sale_of_data only applies in US states; in the EU it simply follows Marketing. */
const sync=c=>privacy().then(cp=>{
  if(!cp||typeof cp.setTrackingConsent!=='function')return;
  let cur=null;try{cur=cp.currentVisitorConsent&&cp.currentVisitorConsent()}catch(e){}
  if(cur&&CATS.every(k=>cur[k]===yes(c[k])))return;
  try{cp.setTrackingConsent({preferences:c.preferences,analytics:c.analytics,marketing:c.marketing,sale_of_data:c.marketing},()=>{})}catch(e){}
});

/* Marketing withdrawn: Meta's first-party cookies go too (Shopify stops the pixel, the cookies would linger). */
const dropMeta=()=>{const h=location.hostname.replace(/^www\./,'');['_fbp','_fbc'].forEach(n=>['',';domain=.'+h,';domain='+h].forEach(d=>{document.cookie=n+'=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/'+d}))};

/* ---- the dialog ---- */
let dlg,panel,title,deny,more,moreLabel,cats,boxes,lastFocus,canEscape=false,closing=0;
const build=()=>{
  document.body.appendChild(tpl.content.cloneNode(true));
  dlg=document.querySelector('[data-eg7-cc]');
  panel=dlg.querySelector('.eg7-cc__panel');
  title=dlg.querySelector('[data-eg7-cc-title]');
  deny=dlg.querySelector('[data-eg7-cc-deny]');
  more=dlg.querySelector('[data-eg7-cc-more]');
  moreLabel=dlg.querySelector('[data-eg7-cc-more-label]');
  cats=dlg.querySelector('#eg7-cc-details');
  boxes=[...dlg.querySelectorAll('[data-eg7-cc-cat]')];
  if(typeof dlg.showModal!=='function')dlg.classList.add('eg7-cc--fallback');

  const choice=()=>Object.fromEntries(boxes.map(b=>[b.dataset.eg7CcCat,b.checked]));
  const custom=()=>boxes.some(b=>b.checked);
  boxes.forEach(b=>b.addEventListener('change',()=>{deny.textContent=custom()?'Gem indstillinger':'Afvis alle'}));
  deny.addEventListener('click',()=>save(custom()?choice():NONE));
  dlg.querySelector('[data-eg7-cc-accept]').addEventListener('click',()=>save(ALL));
  more.addEventListener('click',()=>details(more.getAttribute('aria-expanded')!=='true'));
  /* Escape only closes a reopened banner (a choice already exists); the first time a choice is needed. */
  dlg.addEventListener('cancel',e=>{e.preventDefault();if(canEscape)close()});
  dlg.addEventListener('close',closed);
  if(dlg.classList.contains('eg7-cc--fallback'))dlg.addEventListener('keydown',e=>{if(e.key==='Escape'&&canEscape)close();else if(e.key==='Tab')trap(e)});
};
const details=on=>{
  more.setAttribute('aria-expanded',on?'true':'false');
  moreLabel.textContent=on?'Skjul detaljer':'Vis detaljer';
  cats.hidden=!on;
};
/* Tab stays inside when the browser has no modal <dialog> (showModal makes the page inert by itself). */
const trap=e=>{
  const items=[...dlg.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),summary')].filter(el=>el.offsetParent!==null);
  if(!items.length)return;
  const first=items[0],last=items[items.length-1],a=document.activeElement;
  if(e.shiftKey&&(a===first||a===panel)){e.preventDefault();last.focus()}
  else if(!e.shiftKey&&a===last){e.preventDefault();first.focus()}
};

const open=()=>{
  if(!dlg)build();
  if(dlg.open&&!closing)return;
  clearTimeout(closing);closing=0;dlg.classList.remove('is-leaving');
  boxes.forEach(b=>{b.checked=false});
  deny.textContent='Afvis alle';
  details(false);
  dlg.querySelectorAll('details[open]').forEach(d=>{d.open=false});
  canEscape=!!read();
  lastFocus=document.activeElement;
  root.setAttribute('data-eg7-cc-open','');
  if(!dlg.open){if(dlg.classList.contains('eg7-cc--fallback'))dlg.setAttribute('open','');else dlg.showModal()}
  dlg.querySelector('.eg7-cc__scroll').scrollTop=0;
  panel.focus({preventScroll:true});
  /* the signature: the laser engraves the headline in, once per opening (eg-v6.css, data-eg-engrave) */
  title.removeAttribute('data-eg-engrave');title.classList.remove('is-engraved');
  if(!reduce()&&root.classList.contains('eg-js')){title.setAttribute('data-eg-engrave','');void title.offsetWidth;setTimeout(()=>title.classList.add('is-engraved'),140)}
};
/* Runs however the dialog closed, also when the browser forces it shut (Chrome closes a modal on a second Escape). */
const closed=()=>{
  clearTimeout(closing);closing=0;dlg.classList.remove('is-leaving');
  root.removeAttribute('data-eg7-cc-open');
  if(lastFocus&&lastFocus!==document.body&&document.contains(lastFocus)&&lastFocus.focus)lastFocus.focus({preventScroll:true});
  if(location.hash===HASH)history.replaceState(null,'',location.pathname+location.search);
};
const close=()=>{
  if(!dlg||!dlg.open||closing)return;
  const finish=()=>{
    if(dlg.classList.contains('eg7-cc--fallback')){dlg.removeAttribute('open');closed()}else dlg.close();
  };
  if(reduce())return finish();
  dlg.classList.add('is-leaving');
  closing=setTimeout(finish,200);
};
const save=c=>{
  write(c);
  sync(c);
  if(!c.marketing)dropMeta();
  document.dispatchEvent(new CustomEvent('eg7:consent',{detail:{...c}}));
  close();
};

window.eg7Consent={open,get:()=>read()};

document.addEventListener('click',e=>{
  const t=e.target.closest&&e.target.closest('[data-eg7-consent-open],a[href$="'+HASH+'"]');
  if(!t)return;
  e.preventDefault();open();
});
window.addEventListener('hashchange',()=>{if(location.hash===HASH)open()});

const stored=read();
if(stored)sync(stored);
const designMode=window.Shopify&&window.Shopify.designMode;
if(location.hash===HASH||(!stored&&!designMode))open();
})();
